export const defaultData = {
  contractorDetails: {
    companyName: '',
    engineerName: '',
    gasSafeLicence: '',
    telephone: ''
  },
  siteDetails: {
    siteName: '',
    plantRoomLocation: 'Main Energy Centre Basement',
    siteAddress: '',
    postCode: '',
    serviceDate: new Date().toISOString().split('T')[0]
  },
  chpSpecification: {
    manufacturer: '',
    model: '',
    serialNumber: '',
    fuelType: 'Natural Gas (Methane)',
    electricalOutputKwe: 20.0,
    thermalOutputKwt: 38.0,
    operatingHoursTotal: 4500
  },
  engineAndLubrication: {
    oilSampleTaken: 'Yes',
    oilReplaced: 'Yes - Drained & Refilled',
    oilFilterReplaced: 'Yes',
    sparkPlugsGappedOrReplaced: 'Replaced & Gapped',
    valveClearancesChecked: 'Yes - Within Spec',
    crankcaseBreatherCleaned: 'Yes'
  },
  gasAndCombustion: {
    standingPressureMbar: 22.5,
    runningPressureMbar: 20.0,
    lambdaSensorVoltage: 0.85,
    flueCoPpm: 45,
    flueNoxPpm: 85,
    flueGasTempC: 110,
    flueExhaustSystemIntegrity: 'Pass / Gas Tight'
  },
  electricalGridProtection: {
    g99ProtectionRelayTested: 'Yes - Functional Trip Tested',
    underVoltageTripSec: 200,
    underFrequencyTripSec: 250,
    emergencyStopTested: 'Pass / Immediate Trip',
    gasSolenoidInterlockTested: 'Pass / Shuts on Alarm',
    bmsModbusCommActive: 'Yes'
  },
  declarations: {
    overallStatus: 'SERVICED & RUNNING IN BASELOAD',
    engineerComments: 'Complete scheduled 4,000h service performed. Lubricating oil and spark plugs replaced. G99 relay and emergency interlocks functional.',
    nextServiceDueHours: '8,000 Operating Hours / 6 Months',
    engineerSignature: '',
    clientSignature: ''
  }
};

export default defaultData;
